/**
 * 操作对象的一些工具函数
 */
import { ObjectType, ValueOf } from '@/shared/typings';
/**
 * 从target中取出除去fieldNames的其他所有属性。与Pick相对。
 * @param target
 * @param fieldNames 需要删除的key
 * @returns
 */
export function omit<T extends ObjectType = ObjectType>(target: T, fieldNames: (keyof T)[]): Partial<T> {
  const shallowCopy = { ...target };

  for (const field of fieldNames) {
    Reflect.deleteProperty(shallowCopy, field);
  }

  return shallowCopy;
}

/**
 * 过滤对象值为undefined or null 的属性
 * @param target
 * @param omitValues
 * @returns
 */
export function omitUndefinedOrNull<T extends ObjectType = ObjectType>(
  target: T,
  omitValues: (null | undefined)[] = [null, undefined],
): Partial<T> {
  const shallowCopy = { ...target };

  for (const [field, value] of Object.entries<ValueOf<T>>(target)) {
    if (omitValues.includes(value)) {
      Reflect.deleteProperty(shallowCopy, field);
    }
  }

  return shallowCopy;
}

/**
 * 通过在target中抽取一组属性fieldNames构建一个新对象.
 * @param target
 * @param fieldNames 需要抽取的属性
 * @returns
 */
export function pick<T extends ObjectType = ObjectType>(target: T, fieldNames: (keyof T)[]): Partial<T> {
  const shallowCopy: Partial<T> = {};

  for (const field of fieldNames) {
    Reflect.set(shallowCopy, field, Reflect.get(target, field));
  }

  return shallowCopy;
}
